module.exports = __webpack_public_path__ + "static/media/lightroom.bd3b8b21.svg";